"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("../Tooltip/Container"));

var events = _interopRequireWildcard(require("./events"));

var _Panel = _interopRequireDefault(require("./Panel"));

var _Confirm = _interopRequireDefault(require("./Confirm"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = (0, _Container.default)(events);

function Popover(props) {
  // eslint-disable-next-line
  if (props.content) return _react.default.createElement(Component, props);
  return _react.default.createElement(_Panel.default, props);
}

Popover.displayName = 'ShineoutPopover';
Popover.Confirm = _Confirm.default;
Popover.Confirm.displayName = 'ShineoutPopoverConfirm';
var _default = Popover;
exports.default = _default;